import { Injectable, TemplateRef } from '@angular/core';
import { ResolveStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TopbarService {

  public template: TemplateRef<any>;

  constructor(private router: Router) {

    // Views register their topbar content in their own constructor, which runs
    // after the route has resolved. Dropping the template here keeps the topbar
    // of the previous view from sticking around on views that define none.
    this.router.events
      .pipe(filter(event => event instanceof ResolveStart))
      .subscribe(() => this.template = null);
  }
}
